import { render, staticRenderFns } from "./footerNL.vue?vue&type=template&id=1b353e5f&scoped=true"
import script from "./footerNL.vue?vue&type=script&lang=js"
export * from "./footerNL.vue?vue&type=script&lang=js"
import style0 from "./footerNL.vue?vue&type=style&index=0&id=1b353e5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b353e5f",
  null
  
)

export default component.exports